import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2, RendererStyleFlags2 } from '@angular/core';

@Directive({
  selector: '[appStatus]'
})
export class StatusDirective implements OnInit {
  @Input() appStatus: any;
  @Input() width: any;
  @Input() padding: string | undefined;
  @Input() noWrap = false;
  @Input() looks: string | string[]

  constructor(private element: ElementRef,
    private renderer: Renderer2) { }

  ngOnInit(): void {
    //fixed style: will be applied to every status block
    if (this.looks) {
      this.applyClass(this.toArray(this.looks))
    } else {
      this.renderer.setStyle(this.element.nativeElement, 'color', 'black', RendererStyleFlags2.Important)
      this.renderer.setStyle(this.element.nativeElement, 'display', 'inline-block', RendererStyleFlags2.Important)
      this.renderer.setStyle(this.element.nativeElement, 'padding', this.padding || '3px', RendererStyleFlags2.Important)
      this.renderer.setStyle(this.element.nativeElement, 'border-radius', '4px', RendererStyleFlags2.Important)
      this.renderer.setStyle(this.element.nativeElement, 'text-align', 'center', RendererStyleFlags2.Important)

      if (this.noWrap) {
        this.renderer.setStyle(this.element.nativeElement, 'white-space', 'nowrap', RendererStyleFlags2.Important)
      }

      if (this.width) {
        this.renderer.setStyle(this.element.nativeElement, 'width', this.width, RendererStyleFlags2.Important)
      }
    }

    if (this.appStatus) {
      //apply style on the basis of condition else apply styles directly
      if (this.isSwitchCase()) {
        this.swtichStyle();
      } else {
        this.applyStyle(this.toArray(this.appStatus))
      }
    }
  }

  @HostListener('onChange', ['$event.detail'])
  onChange(data: any) {
    if (data.style) {
      this.removeStyle();
      this.applyStyle(data.style)
    } else {
      this.removeClass(this.toArray(data.class.previous));
      this.applyClass(this.toArray(data.class.current));
    }
  }

  private isSwitchCase(): boolean {
    let argKeys = Object.keys(this.appStatus);
    return ['switch', 'case'].every(key => argKeys.includes(key))
  }

  private swtichStyle() {
    let matchFound = false;

    for (const caze of Object.keys(this.appStatus.case)) {
      if (this.appStatus.switch == caze) {
        matchFound = true;
        this.applyStyle(this.toArray(this.appStatus.case[caze]))
        break;
      }
    }

    if (!matchFound) {
      this.applyStyle(this.toArray(this.appStatus.default))
    }
  }

  private toArray(element: any) {
    return Array.isArray(element) ? element : [element]
  }

  private applyStyle(styles: string[]) {
    if (styles.length == 2) {
      this.renderer.setStyle(this.element.nativeElement, 'border', `1px solid ${styles[0]}`, RendererStyleFlags2.Important)
      this.renderer.setStyle(this.element.nativeElement, 'background', styles[1], RendererStyleFlags2.Important)
    } else {
      this.applyClass(styles)
    }
  }

  private removeStyle() {
    this.renderer.removeStyle(this.element.nativeElement, 'border')
    this.renderer.removeStyle(this.element.nativeElement, 'background')
  }

  private applyClass(classes: string[]) {
    classes.forEach(clazz => this.renderer.addClass(this.element.nativeElement, clazz))
  }

  private removeClass(classes: string[]) {
    classes.forEach(clazz => this.renderer.removeClass(this.element.nativeElement, clazz));
  }
}